export default __webpack_public_path__ + "static/media/message_icon.cd1edd95.svg";